export const MANAGER_ROLE_IDS = [1,5,12,14,20,21,28,29]

export const CAN_ASSIGN_ROLE_IDS = [1,5,6,7,20,21,24,29,28]
